/*
  Nawigacja LP:
  1. scroll-spy — link sekcji, która zajmuje górną część ekranu, dostaje klasę
     header__active-menu-item (desktop: zostaje linia pod linkiem; drawer: podkreślenie);
  2. kliknięcie kotwicy w drawerze zamyka drawer (ta sama strona, więc Dawn sam go nie zamknie).
*/
(() => {
  const links = Array.from(document.querySelectorAll('[data-bandit-nav-link]'));
  if (!links.length) return;

  const targets = new Map();
  links.forEach((link) => {
    const id = (link.getAttribute('href') || '').split('#')[1];
    if (!id) return;
    const section = document.getElementById(id);
    if (!section) return;
    if (!targets.has(section)) targets.set(section, []);
    targets.get(section).push(link);
  });

  const sections = Array.from(targets.keys());
  let current = null;

  const setActive = (section) => {
    if (section === current) return;
    current = section;
    const active = section ? targets.get(section) : [];
    links.forEach((link) => link.classList.toggle('header__active-menu-item', active.includes(link)));
  };

  const update = () => {
    const probe = window.scrollY + window.innerHeight * 0.35;
    let found = null;
    for (const section of sections) {
      const top = section.getBoundingClientRect().top + window.scrollY;
      if (top <= probe) found = section;
    }
    setActive(found);
  };

  let ticking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    },
    { passive: true }
  );
  window.addEventListener('resize', update);
  update();

  const drawer = document.querySelector('header-drawer');
  if (drawer) {
    // HeaderDrawer.closeMenuDrawer wymaga elementu do zwrócenia fokusu (bez niego
    // wychodzi od razu) — podajemy przycisk hamburgera.
    const summary = drawer.querySelector('summary');
    drawer.querySelectorAll('a[href*="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (typeof drawer.closeMenuDrawer === 'function' && summary) drawer.closeMenuDrawer(event, summary);
        // Dawn zdejmuje aria-expanded tylko przy kliknięciu w sam hamburger; bez tego
        // szara warstwa (.header__icon--menu[aria-expanded='true']::before) zostaje na ekranie.
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });
    });
  }
})();
